export default "__VITE_ASSET__BLZrXiqZ__"